export default {
  // Grey general note (restored per PM video) — the full one-per-order rule, shown on the
  // offer sheet and the promo/gift modal. Automatic discounts (smart pricing) still stack.
  general_note:
    "I codici promo e le gift card non possono essere combinati con altri sconti. Un'offerta e un riscatto punti possono essere usati insieme. Gli sconti automatici come lo sconto asporto si applicano comunque.",
  // Full note — offer detail sheet + promo/gift entry (CTO shortened to one line, 2026-07-31).
  full_note: 'I codici promo e le gift card non possono essere combinati con altri sconti.',
  // Green status pill on the offer sheet when the offer's requirement is met (prototype).
  unlocked: 'Sbloccato',
  // Short static exclusion note per surface (card footers, CTO-confirmed copy).
  footer: {
    offer: 'Non combinabile con codici promo o gift card.',
    promo: 'Non combinabile con offerte, gift card o punti.',
    gift: 'Non combinabile con offerte, codici promo o punti.',
  },
  // State-aware conflict line — names the discount that will be displaced.
  // Full mutual exclusivity (PM video): offer, promo, gift and points all block each other.
  conflict: {
    offer_blocked_by_promo: 'È applicato un codice promo. Applicare questa offerta lo rimuoverà.',
    offer_blocked_by_gift: 'È applicata una gift card. Applicare questa offerta la rimuoverà.',
    offer_blocked_by_points: 'È attivo un riscatto punti. Applicare questa offerta lo rimuoverà.',
    promo_gift_displaces_offer: 'Applicare un codice promo o una gift card rimuoverà la tua offerta attiva.',
    promo_gift_displaces_points: 'Applicare un codice promo o una gift card rimuoverà il tuo riscatto punti.',
    promo_gift_displaces_offer_and_points:
      'Applicare un codice promo o una gift card rimuoverà la tua offerta attiva e il riscatto punti.',
  },
  // Comparison-choice card (Inc 4, FOO-2567) — offer / promo detail modals when a conflicting
  // discount is already applied. Lets the customer pick, flagging the higher saving as best.
  comparison: {
    active_line: 'Questo {{kind}} è già attivo: {{name}} ({{saving}}).',
    active_line_no_saving: 'Questo {{kind}} è già attivo: {{name}}.',
    candidate_line: 'Il {{kind}} fa risparmiare {{saving}}.',
    only_one: 'Puoi usarne solo uno.',
    best_choice: 'Scelta migliore',
    keep: 'Mantieni {{label}}',
    use_instead: 'Usa {{label}} invece',
    kinds: {
      offer: 'offerta',
      promo: 'codice promo',
      gift: 'gift card',
      points: 'riscatto punti',
    },
    // Concise nouns for the Keep/Use buttons ("Keep offer", "Use code instead").
    button_kinds: {
      offer: 'offerta',
      promo: 'codice',
      gift: 'gift card',
      points: 'punti',
    },
    // Single-action variant (offer modal, promo/gift already active): one sentence + only the
    // "Use offer instead" button — closing the window keeps the code (CTO 2026-08-03).
    single_message:
      '{{active}} è già attivo. Solo uno sconto per ordine — usa questa offerta o chiudi questa finestra per mantenere il tuo codice.',
    active_named: {
      promo: 'Codice promo {{name}} ({{saving}})',
      gift: 'Gift card ({{saving}})',
    },
    active_named_no_saving: {
      promo: 'Codice promo {{name}}',
      gift: 'Gift card',
    },
    // Multiple active offers (item 6) — promo modal comparison, replaces the active/candidate lines.
    active_offers_two:
      'Hai {{count}} offerte attive: {{first}} ({{firstValue}}) e {{second}} ({{secondValue}}) — {{total}} in totale. Il codice promo {{code}} fa risparmiare {{codeValue}} su questo ordine. È possibile usarne solo uno.',
    active_offers_more:
      'Hai {{count}} offerte attive: {{first}} ({{firstValue}}), {{second}} ({{secondValue}}) e altre {{more}} — {{total}} in totale. Il codice promo {{code}} fa risparmiare {{codeValue}} su questo ordine. È possibile usarne solo uno.',
  },
  // Discount-card status tag (deals carousel — offer + promo cards), Inc 3.
  card: {
    available: 'Disponibile ora',
    applied: 'Applicato · {{savings}} di sconto',
    applied_plain: 'Applicato',
    replaces: 'Non combinabile con {{label}} · Sostituisce {{name}}',
    replaces_no_name: 'Non combinabile con {{label}}',
    // Prototype card treatment (blocked-by-conflict): a warning line naming the active discount,
    // the one-per-order note, and a "Replaces …" line.
    cannot_combine: 'Non combinabile con {{name}}',
    replaces_name: 'Sostituisce {{name}}',
    // Multiple active offers (n>1) — show a count + total instead of a single offer name (item 6).
    cannot_combine_offers: 'Non combinabile con le tue {{count}} offerte attive',
    replaces_offers: 'Sostituisce {{count}} offerte attive ({{total}})',
    // Generic type label for the active discount that would be displaced.
    kind: {
      offer: "un'offerta",
      promo: 'un codice promo',
      gift: 'una gift card',
      points: 'il tuo riscatto punti',
    },
  },
  // DisplacementNotice (cart drawer + checkout) — bidirectional & entity-named (PM video).
  // One discount displaced another; the message names both, and Undo restores the displaced one.
  // e.g. "Promo code CHEVERE applied. This removed the 2-für-1 offer. [Undo]".
  displacement: {
    message: '{{applied}} applicato. Rimosso: {{removed}}.',
    // Multiple offers removed at once (item 6) — names the top two + the total, in cart + checkout.
    offer_removed_multi: {
      promo:
        'Codice promo {{code}} ({{codeValue}}) applicato. Rimosse {{count}} offerte: {{first}} e {{second}} ({{total}}).',
      gift: 'Gift card applicata. Rimosse {{count}} offerte: {{first}} e {{second}} ({{total}}).',
    },
    undo: 'Annulla',
    // The discount that is currently applied (the "winner").
    applied: {
      offer: 'Offerta {{name}}',
      promo: 'Codice promo {{code}}',
      gift: 'Gift card',
      points: '{{count}} punti',
    },
    // The discount that was displaced (the "loser"), restored by Undo.
    removed: {
      offer: "l'offerta {{name}}",
      promo: 'il codice promo {{code}}',
      gift: 'la gift card',
      points: 'il tuo riscatto punti',
    },
    // UX feedback item 3 — points redemption displacing a promo/gift. Layer A: a zero-friction hint
    // under the "Use your points" header, shown only while a code/gift is active (before they tap).
    points_hint: {
      promo: "L'utilizzo dei punti rimuoverà il codice promo {{name}} (–{{saving}})",
      gift: "L'utilizzo dei punti rimuoverà la gift card (–{{saving}})",
      promo_no_saving: "L'utilizzo dei punti rimuoverà il codice promo {{name}}",
      gift_no_saving: "L'utilizzo dei punti rimuoverà la gift card",
    },
    // Layer B: the post-action displacement notice, extended to the points→code direction.
    points_displaced: {
      promo: '{{points}} punti applicati (–{{pointsSaving}}). Codice promo {{name}} (–{{couponSaving}}) rimosso.',
      gift: '{{points}} punti applicati (–{{pointsSaving}}). Gift card (–{{couponSaving}}) rimossa.',
      promo_no_saving: '{{points}} punti applicati (–{{pointsSaving}}). Codice promo {{name}} rimosso.',
      gift_no_saving: '{{points}} punti applicati (–{{pointsSaving}}). Gift card rimossa.',
    },
  },
};
